import React from "react";
import { osControlKey, isMobile } from "./os.js";
import { AiOutlineSearch } from "react-icons/ai";

var Launcher = function Launcher(_ref) {
  var text = _ref.text,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    id: "commandbar-user-launcher-component",
    className: "commandbar-user-launcher",
    style: style || {},
    onClick: function onClick() {
      var _window, _window$CommandBar;

      (_window = window) === null || _window === void 0 ? void 0 : (_window$CommandBar = _window.CommandBar) === null || _window$CommandBar === void 0 ? void 0 : _window$CommandBar.open();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "commandbar-user-launcher__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "commandbar-user-launcher__prefix"
  }, /*#__PURE__*/React.createElement(AiOutlineSearch, null), "\xA0 ", text || "Find anything"), !isMobile() && /*#__PURE__*/React.createElement("div", {
    className: "commandbar-user-launcher__suffix"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 3
    },
    className: "commandbar-user-launcher__tag"
  }, osControlKey()), /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: 3
    }
  }, "+"), /*#__PURE__*/React.createElement("span", {
    className: "commandbar-user-launcher__tag "
  }, "K"))));
};

export default Launcher;